import { hmapPathParamConfig, hmapPathParamRegex } from "@ngmodules/hmap/hmap.routes";
export const CrmRoutes = [
    {
        "url": "/brand/:brand_id/crm?tab",
        "name": "appLayout.harriSH.crm",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "component": "crmContainer",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['crm', 'centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/crm/crm.downgrade.module");
                }
            },
        ]
    },
    {
        "url": `/crm/${hmapPathParamRegex}?tab`,
        "name": "appLayout.harriSH.access-portal.settings.crm",
        "params": {
            ...hmapPathParamConfig
        },
        "type": "frontend",
        "showSettingsHeader": true,
        "showGlobalSearch": true,
        "loginRequired": true,
        "component": "crmContainer",
        "onEnter": ['$stateParams', '$state', 'hmapService', 'userPermissions', 'brandServices', 'talentPoolDataService', async function ($stateParams, $state, hmapService, userPermissions, brandServices, talentPoolDataService) {
                const activeBrandId = hmapService.getActiveBrandId($stateParams['hmapPath']);
                const [policyParser, isGlobalTalentPoolEnabled,] = await Promise.all([
                    userPermissions.getBrandPolicy(activeBrandId),
                    brandServices.check(brandServices.SERVICES.GLOBAL_TALENT_POOL, activeBrandId),
                ]);
                if (!isGlobalTalentPoolEnabled ||
                    !policyParser.has(userPermissions.PERMISSIONS['MANAGE_TALENT_POOL_CRM'])) {
                    Utils.redirectToWorkspace('appLayout.harriSH.access-portal.main', { hmapPath: $stateParams['hmapPath'] });
                }
                const talentPoolSettings = await talentPoolDataService.getBrandTalentPoolSettings(activeBrandId);
                if (!talentPoolSettings.enable_candidate_relationship_management) {
                    Utils.redirectToWorkspace('appLayout.harriSH.access-portal.main', { hmapPath: $stateParams['hmapPath'] });
                }
            }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['crm', 'centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/crm/crm.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/campaign/create?campaign_id&brand_id&source",
        "name": "appLayout.harriSH.create-campaign",
        "type": "frontend",
        "loginRequired": true,
        "reloadOnSearch": false,
        "showGlobalSearch": true,
        "component": 'crmCampaignWizardContainer',
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['crm', 'centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/crm/crm.downgrade.module");
                }
            },
        ]
    },
    {
        "url": `/campaign/create/${hmapPathParamRegex}?campaign_id&brand_id&source`,
        "name": "appLayout.harriSH.access-portal.settings.create-campaign",
        "type": "frontend",
        "params": {
            ...hmapPathParamConfig
        },
        "loginRequired": true,
        "reloadOnSearch": false,
        "showGlobalSearch": true,
        "component": 'crmCampaignWizardContainer',
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['crm', 'centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/crm/crm.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/email/create?email_id&brand_id&source",
        "name": "appLayout.harriSH.create-email",
        "type": "frontend",
        "loginRequired": true,
        "reloadOnSearch": false,
        "showGlobalSearch": true,
        "component": 'createNewEmailComponent',
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['crm', 'centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/crm/crm.downgrade.module");
                }
            },
        ]
    },
    {
        "url": `/email/create/${hmapPathParamRegex}?email_id&brand_id&source`,
        "name": "appLayout.harriSH.access-portal.settings.create-email",
        "type": "frontend",
        "params": {
            ...hmapPathParamConfig
        },
        "loginRequired": true,
        "reloadOnSearch": false,
        "showGlobalSearch": true,
        "component": 'createNewEmailComponent',
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['crm', 'centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/crm/crm.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/text-message/create?message_id&brand_id&source",
        "name": "appLayout.harriSH.create-message",
        "type": "frontend",
        "loginRequired": true,
        "reloadOnSearch": false,
        "showGlobalSearch": true,
        "component": 'createNewTextMessageComponent',
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['crm', 'centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/crm/crm.downgrade.module");
                }
            },
        ]
    },
    {
        "url": `/text-message/create/${hmapPathParamRegex}?message_id&brand_id&source`,
        "name": "appLayout.harriSH.access-portal.settings.create-message",
        "type": "frontend",
        "params": {
            ...hmapPathParamConfig
        },
        "loginRequired": true,
        "reloadOnSearch": false,
        "showGlobalSearch": true,
        "component": 'createNewTextMessageComponent',
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['crm', 'centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/crm/crm.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/campaign/unsubscribe?token",
        "name": "campaign-unsubscribe",
        "type": "frontend",
        "loginRequired": true,
        "reloadOnSearch": false,
        "showGlobalSearch": true,
        "component": 'campaignUnsubscribeContainer',
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['crm', 'centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/crm/crm.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/:view?tab",
        "name": "appLayout.harriSH.settings.brandSection",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['crm', 'centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/crm/crm.downgrade.module");
                }
            },
        ]
    },
];
//# sourceMappingURL=crm.routes.js.map